import elementPlusEn from 'element-plus/es/locale/lang/en'
import elementPlusId from 'element-plus/es/locale/lang/id'
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '~/constants/language'
import { COPY as EN_COPY, ELEMENT_PLUS_COPY as EN_OVERRIDES } from './en'
import { COPY as ID_COPY, ELEMENT_PLUS_COPY as ID_OVERRIDES } from './id'
import { deepMerge } from './merge'

// One entry point for language: consumers import the constants from here.
export { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES }
  from '~/constants/language'

/**
 * One bundle per language. `elementPlus` holds only the keys this app
 * re-words; everything else comes from the library locale.
 */
const BUNDLES = {
  id: { copy: ID_COPY, elementPlus: ID_OVERRIDES, base: elementPlusId },
  en: { copy: EN_COPY, elementPlus: EN_OVERRIDES, base: elementPlusEn },
}

/**
 * The locale object handed to `<el-config-provider :locale>` per language.
 * Built once at module load. The merge is DEEP: a shallow spread would drop
 * every library string the override does not name.
 */
const ELEMENT_LOCALES = Object.fromEntries(
  Object.entries(BUNDLES).map(([language, bundle]) => [
    language,
    deepMerge(bundle.base, { el: bundle.elementPlus }),
  ]),
)

/** Accepts `en`, `en-US`, `EN`; anything else falls back to the default. */
export function normalizeLanguage(value) {
  const raw = String(value ?? '').trim().toLowerCase()

  if (SUPPORTED_LANGUAGES.includes(raw)) {
    return raw
  }

  const base = raw.split(/[-_]/)[0]

  return SUPPORTED_LANGUAGES.includes(base) ? base : DEFAULT_LANGUAGE
}

export function elementLocaleFor(language) {
  return ELEMENT_LOCALES[normalizeLanguage(language)]
}

export function copyFor(language) {
  return BUNDLES[normalizeLanguage(language)].copy
}

/**
 * Read a copy value by dotted path. Returns `fallback` when the path is
 * absent, so a copy gap never renders `undefined`.
 */
export function translate(copy, path, fallback = '') {
  const found = String(path)
    .split('.')
    .reduce((node, key) => (node == null ? undefined : node[key]), copy)

  return found ?? fallback
}
